import React, { useState } from "react";
import { useHistory } from "react-router";
import { Button, Card, Group, Modal, Stack, Text, TextInput, Title } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { updateChecklistThunk } from "../checklistSlice";
import { ChecklistStatusEnum } from "../constants";
import { setShowSuccessMessageThunk } from "../../../../global/globalSlice";

const ChecklistRemove: React.FC<{ disabled?: boolean }> = ({ disabled = false }) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const project = useAppSelector((state) => state.adminReducer.project);
  const checklist = useAppSelector((state) => state.checklistReducer.checklist);
  const [removeModalOpen, setRemoveModalOpen] = useState<boolean>(false);
  const [removeNameCheck, setRemoveNameCheck] = useState<string>("");

  const openModal = () => {
    setRemoveNameCheck("");
    setRemoveModalOpen(true);
  };

  const removeChecklist = async () => {
    dispatch(updateChecklistThunk("status", ChecklistStatusEnum.REMOVED, checklist.status));
    dispatch(setShowSuccessMessageThunk("Slettet"));

    setRemoveModalOpen(false);
    history.push(`/project/${project._id}/checklist`);
  };

  return (
    <>
      <Card w="100%" p="sm" bg="#f8f9fa" bd="1px solid var(--mantine-color-warmgray-2)" style={{ overflow: "visible" }}>
        <Stack gap="xs">
          <Title order={4} fw={400} lh={1.25} m={0}>
            Slett {checklist.isTemplate === true ? "mal" : "sjekkliste"}
          </Title>
          <Button
            variant="danger-filled"
            onClick={openModal}
            disabled={disabled}
            w="150px"
            leftSection={<i className="fa fa-remove fa-fw" />}
          >
            Slett
          </Button>
        </Stack>
      </Card>
      <Modal
        opened={removeModalOpen}
        onClose={() => setRemoveModalOpen(false)}
        title={`Slett ${checklist.name}`}
        centered
      >
        <Stack gap="sm">
          <Text size="sm">
            Bekreft navnet på {checklist.isTemplate === true ? "malen" : "sjekklisten"} som skal slettes
          </Text>
          <TextInput value={removeNameCheck} onChange={(e) => setRemoveNameCheck(e.currentTarget.value)} />
          <Group justify="flex-end" mt="xs">
            <Button variant="default" onClick={() => setRemoveModalOpen(false)}>
              Avbryt
            </Button>
            <Button
              variant="danger-filled"
              disabled={removeNameCheck.toLocaleLowerCase() !== checklist.name.toLocaleLowerCase()}
              onClick={removeChecklist}
              leftSection={<i className="fa fa-trash fa-fw" />}
            >
              Slett
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
};

export default ChecklistRemove;
